import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
  message,
  notification,
} from "antd";
import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { columnsTableMenu, optionsLieuDung } from "./PrescriptionTable.config";
import "./PrescriptionTable.scss";
import {
  Medicine,
  UnitMedicine,
  UsageMedicine,
} from "types/models/examination-diagnostic-type";
import { medicineStoreService, medicalExaminationService } from "api";
import { unitStoreService } from "api";
import { usageStoreService, storeService } from "api";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { inpatientService } from "api";
import SaveNewGoiThuoc from "./SaveNewGoiThuoc/SaveNewGoiThuoc";
import Icons from "assets/icons";
import { Notification } from "components/common";

const PrescriptionTable = React.forwardRef((props, ref) => {
  // redux
  const idDDNT = useAppSelector((state) => state.residentialNurse.idDDNT);
  //
  const [dataSource, setDataSource] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [medicines, setMedicines] = useState<Medicine[]>([]);

  const [unitMedicine, setUnitMedicine] = useState<UnitMedicine[]>([]);

  const [usageMedicine, setUsageMedicine] = useState<UsageMedicine[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaiThuoc, setLoaiThuoc] = useState<any>([]);
  const [form] = Form.useForm();

  const [count, setCount] = useState<number>(1);
  const goiThuocColumns = [
    {
      title: "Tên gói",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "",
      dataIndex: "action",
      width: "4%",
      render: (v, r, i) => {
        return (
          <Space>
            <Tooltip title="Kê">
              <Button
                type="text"
                icon={<Icons.edit />}
                onClick={() => onKe(r)}
              ></Button>
            </Tooltip>
            <Tooltip title="Xoá">
              <Button
                type="text"
                danger
                icon={<Icons.remove />}
                onClick={() => delGoiThuoc(r)}
              ></Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];
  const onKe = (record: any) => {
    setDataSource([
      ...record.medicines.map((it) => ({
        key: it.id,
        idThuoc: it.id,
        tenThuoc: it.name,
        nongDo: it.hamLuong,
        hoatChat: it.hoatChat,
        soLuong: it.soLuong,
        donVi: it.donViTinh,
        lieuDung: it.lieuDung,
      })),
    ]);
    setSelectedRowKeys([]);
  };
  const delGoiThuoc = async (record) => {
    try {
      let response = await storeService.delGoiThuoc({
        id: record.id,
      });
      fetchListGoiThuoc({ page: 1, limit: 20 });
    } catch (err) {
      notification.error({ message: "Lỗi khi xóa gói thuốc" });
    }
  };
  const [goiThuocs, setGoiThuocs] = useState<any>([]);
  const [selectedDonThuocs, setSelectedDonThuocs] = useState<any>([]);
  const gTRef = useRef<any>();

  const fetchListGoiThuoc = async (params) => {
    try {
      setLoading(true);
      let response = await storeService.getListGoiThuoc(params);
      setGoiThuocs(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      notification.error({ message: "Lỗi khi lấy danh sách gói thuốc!" });
    }
  };
  // const onSelectRow = (record, selected, selectedRows, event) => {
  //   setSelectedRowKeys(selectedRows.map((it) => it.key));
  //   setSelectedDonThuocs(selectedRows);
  // };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };
  useImperativeHandle(ref, () => ({
    getDataSource: () => {
      return dataSource;
    },
    setDataSource: (data) => {
      setCount(data.length + 1);
      setDataSource(
        data.map((it, idx) => ({
          key: it.id,
          idThuoc: it.idThuoc,
          tenThuoc: it.tenThuoc,
          nongDo: it.nongDo,
          hoatChat: it.hoatChat,
          donVi: it.donVi,
          soLuong: it.soLuong,
          lieuDung: it.lieuDung,
        }))
      );
    },
    getData: (idDTNT) => {
      return dataSource.map((it) => ({
        key: it.id,
        idDieuTriNoiTru: idDTNT,
        maThuoc: it.idThuoc,
        tenThuoc: it.tenThuoc,
        nongDo: it.nongDo,
        hoatChat: it.hoatChat,
        donVi: it.donVi,
        soLuong: it.soLuong,
        lieuDung: it.lieuDung,
      }));
    },
  }));
  const reloadGT = () => {
    fetchListGoiThuoc({ page: 1, limit: 100 });
  };
  const fetchLoaiThuoc = async (params) => {
    try {
      setLoading(true);
      let response = await medicineStoreService.getListLoaiThuoc(params);
      setLoaiThuoc(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const getMedicine = async () => {
    setLoading(true);
    try {
      const response = await medicineStoreService.layDanhMucThuoc();
      setMedicines(response.data);
    } catch {
      Notification("eror", "Lấy danh mục thuốc thất bại!");
    }
    setLoading(false);
  };

  const [thuocs, setThuocs] = useState<any>([]);
  const fetchListThuocByParam = async (params) => {
    try {
      setLoading(true);
      let response = await storeService.getListMedicineByParams(params);
      setThuocs(response);
      setLoading(false);
    } catch (err) {
      setLoading(true);
      Notification("eror", "Lỗi khi lấy danh sách thuốc!");
    }
  };
  const [tinhTrangBaoHiem, setTinhTrangBaoHiem] = useState<any>([]);
  const fetchDanhMucTinhTrangBaoHiem = async (params) => {
    try {
      setLoading(true);
      let response = await inpatientService.getDanhMucCoDinh(params);
      setTinhTrangBaoHiem(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(true);
      Notification("eror", "Lỗi khi lấy danh sách thuốc!");
    }
  };

  const getUnit = async () => {
    setLoading(true);
    try {
      const response = await unitStoreService.getUnit();
      setUnitMedicine(response.data.data);
    } catch {
      message.error("Lấy danh sách đơn vị thuốc thất bại!");
    }
    setLoading(false);
  };

  const getUsage = async () => {
    setLoading(true);
    try {
      const response = await usageStoreService.getUsage();
      setUsageMedicine(response.data.data);
    } catch {
      message.error("Lấy danh sách cách dùng thuốc thất bại!");
    }
    setLoading(false);
  };
  const selectedDTSave = useMemo(() => {
    let data = [];
    dataSource.map((it) => {
      const tmp = selectedDonThuocs.find((dt) => dt.key == it.key);
      if (!!tmp) data = [...data, it];
    });
    return data;
  }, [selectedDonThuocs, dataSource]);

  const handleSaveGoiThuoc = async () => {
    if (selectedDTSave.length > 0) {
      gTRef.current?.setData([...selectedDTSave]);
      gTRef.current?.openModal();
    } else {
      Notification("info", "Hãy chọn thuốc để lưu!");
    }
  };

  useEffect(() => {
    getMedicine();
    getUnit();
    getUsage();
    fetchListThuocByParam({});
    fetchDanhMucTinhTrangBaoHiem("tinh_trang_bao_hiem");
    fetchLoaiThuoc({});
    fetchListGoiThuoc({ page: 1, limit: 100 });
  }, []);

  const columns = columnsTableMenu.map((col) => {
    if (col.dataIndex === "idThuoc") {
      return {
        ...col,
        options: [
          ...thuocs.map((it) => ({
            value: it.id,
            label: it.id,
          })),
        ],
      };
    }
    if (col.dataIndex === "tenThuoc") {
      return {
        ...col,
        options: [
          ...thuocs.map((it) => ({
            value: it.name,
            label: it.name,
          })),
        ],
      };
    } else if (col.dataIndex === "donVi") {
      return {
        ...col,
        options: [
          ...unitMedicine.map((unit) => {
            return {
              value: unit.name,
              label: unit.name,
            };
          }),
        ],
      };
    } else if (col.dataIndex === "lieuDung") {
      return {
        ...col,
        options: optionsLieuDung,
      };
    } else return col;
  });
  useEffect(() => {}, [dataSource]);
  return (
    <Row className="prescription-table-container">
      <Space direction="vertical" className="prescription-space">
        <Row gutter={[8, 8]}>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            <TableInputAdd
              column={columns}
              data={dataSource}
              setData={setDataSource}
              pagination={false}
              thuocs={thuocs}
              loading={loading}
              count={count}
              setCount={setCount}
              rowSelection={{
                // onSelect: onSelectRow,
                // selectedRowKeys: selectedRowKeys,
                ...rowSelection,
              }}
            />
          </Col>
        </Row>
        <Row gutter={[0, 8]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              label={
                <Typography.Text ellipsis>Kết luận của BS</Typography.Text>
              }
              name="ketLuanBacSy"
              labelAlign="left"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              <Input placeholder="Nhập" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              label={<Typography.Text ellipsis>Hẹn tái khám</Typography.Text>}
              name="taiKham"
              labelAlign="left"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              <DatePicker
                placeholder="DD/MM/YYYY"
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[0, 8]}>
          <Row justify={"end"}>
            <SaveNewGoiThuoc ref={gTRef} reload={reloadGT} />
            <Button
              type="text"
              className="btn-sub"
              icon={<Icons.save />}
              onClick={handleSaveGoiThuoc}
            >
              Lưu gói thuốc
            </Button>
          </Row>
          <Row>
            <Table
              rowKey={(record) => record.id}
              columns={goiThuocColumns}
              dataSource={goiThuocs}
              bordered
              rowSelection={{
                type: "radio",
              }}
              loading={loading}
            />
          </Row>
        </Row>
      </Space>
    </Row>
  );
});

export default PrescriptionTable;
